import { ApolloClient, InMemoryCache } from "@apollo/client";

const client = new ApolloClient({
//   uri: 'http://localhost:8000/graphql',
  uri: 'https://ahoy-graphql-api-ethindia.vercel.app/graphql',
  // credentials: 'include',
  cache: new InMemoryCache(),
});

export default client;